__webpack_require__.p = "https://staging.sparqle.tech/";